import { createSlice } from "@reduxjs/toolkit";
import { IInquiry } from "src/@types/inquiries";
import { CURRENT_INQUIRY_SLICE_NAME } from "./actions";
import { getCurrentInquiryReducer } from "./reducers";

export interface ICurrentInquiryState {
  isLoading: boolean;
  item: IInquiry;
}

const initialState: ICurrentInquiryState = {
  isLoading: false,
  item: null,
};

export const { reducer: currentInquiry } = createSlice({
  name: CURRENT_INQUIRY_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getCurrentInquiryReducer(builder);
  },
});
